/* eslint-disable import/prefer-default-export */
const CardSettingsActionTypes = {
  CHANGE_SCREEN: 'change_screen',
  UPDATE_USER: 'update_user',
  UPDATE_CARD_STATUS: 'update_card_status',
};

const CardSettingsReducer = (state, action) => {
  switch (action.type) {
    case CardSettingsActionTypes.CHANGE_SCREEN:
      return {
        ...state,
        currentScreen: action.payload.screen,
        screenOptions: action.payload.options,
      };
    case CardSettingsActionTypes.UPDATE_USER:
      return {
        ...state,
        user: {
          isUS: action.payload?.isUS,
          cardProvider: action.payload?.cardProvider,
          firstName: action.payload?.firstName,
          lastName: action.payload?.lastName,
          mailingAddresses: action.payload?.mailingAddresses,
        },
      };
    case CardSettingsActionTypes.UPDATE_CARD_STATUS:
      return {
        ...state,
        cardStatus: action.payload,
      };
    default:
      return state;
  }
};

const openScreen =
  (dispatch) =>
  (screen, options = {}) =>
    dispatch({ type: CardSettingsActionTypes.CHANGE_SCREEN, payload: { screen, options } });

const updateUser = (dispatch) => (userData) =>
  dispatch({ type: CardSettingsActionTypes.UPDATE_USER, payload: userData });

const updateUserCardStatus = (dispatch) => (cardStatus) =>
  dispatch({ type: CardSettingsActionTypes.UPDATE_CARD_STATUS, payload: cardStatus });

export const cardSettings = {
  CardSettingsReducer,
  actions: {
    openScreen,
    updateUser,
    updateUserCardStatus,
  },
};
